import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '14px',
    backgroundColor: ({ selected }) => selected ? 'var(--color-neutral-400)' : 'var(--color-surface-050)',
    color: ({ selected }) => selected ? 'var(--text-color-main) !important' : 'var(--text-color-main)',
    width: '460px',
    padding: '18px 24px',
    transition: 'background .25s ease-in-out',
    '&:hover': {
      textDecoration: 'none',
      borderColor: 'var(--border-color-neutral-emphasis)',
      backgroundColor: 'var(--color-neutral-400)',
      cursor: 'pointer'
    },
    '& .__body': {
    },
    '& .__indicators': {
      width: '8px'
    },
    '& .__title': {
      fontWeight: 600
    }
  },
  lastMessagePreview: {
    fontWeight: 100
  }
}))

const ConversationListItem = ({ item, clientId, selectedConversation }) => {
  const selected = useMemo(() => {
    return selectedConversation === item.conversationKey
  }, [item.conversationKey, selectedConversation])
  const classes = useStyles({ selected })

  return (
    <Link to={`/conversations/c/${clientId}/t/${item.conversationKey}`} replace className={classes.listItem}>
      <div className='__body'>
        <div className='__title'>{item.name}</div>
        <div className={classes.lastMessagePreview}>{item.lastMessagePreview}</div>
      </div>
      <div className='__indicators'>
        &nbsp;
      </div>
    </Link>
  )
}

ConversationListItem.propTypes = {
  clientId: PropTypes.number,
  item: PropTypes.shape({
    conversationKey: PropTypes.string,
    name: PropTypes.string,
    lastMessagePreview: PropTypes.string
  }),
  selectedConversation: PropTypes.string
}

export default ConversationListItem
